import { getUsers } from '@/febos/servicios/api/usuarios.api';
import { ioCompanyGroups, getUsersByGroup } from '@/febos/servicios/api/empresas.api';
import { listApprovals } from '@/febos/servicios/api/aprobaciones.api';
import { clOpcionesEmpresaList } from '@/febos/servicios/api/configuraciones.api';
import { listOptions as listOptionsDocDigital } from '@/febos/servicios/api/docDigital.api';
import {
  listOptions,
  listV2OptionsWithCompany,
  listOptionsWithCustomParams
} from '@/febos/servicios/api/opciones.api';
import { getProfiles } from '@/febos/servicios/api/perfiles.api';

export const fetchDocumentTypes = async ({ commit }) => {
  commit('SET_DOCUMENT_TYPES_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'tipos.documentos-ed',
    deshabilitado: 'no'
  });

  commit('SET_DOCUMENT_TYPES', response.data.opciones);
  commit('SET_DOCUMENT_TYPES_LOADING', false);
};

export const fetchDocumentTypesExternals = async ({ commit }, company) => {
  commit('SET_DOCUMENT_TYPES_EXTERNALS_LOADING', true);
  const response = await listOptions({
    grupoOpcion: 'tipos.documentos.externos-ed',
    deshabilitado: 'no',
    company
  });
  commit('SET_DOCUMENT_TYPES_EXTERNALS', response.data.opciones);
  commit('SET_DOCUMENT_TYPES_EXTERNALS_LOADING', false);
};

export const fetchDocumentProcess = async ({ commit }, props) => {
  commit('SET_DOCUMENT_PROCESS_LOADING', true);
  const { company, group = 'procesos-siss' } = props;

  const response = await listV2OptionsWithCompany({
    payload: {
      grupoOpcion: group,
      filtros: 'padre:null|deshabilitado:0'
    },
    company
  });

  commit('SET_DOCUMENT_PROCESS', response.data.opciones);
  commit('SET_DOCUMENT_PROCESS_LOADING', false);
};

export const fetchDocumentSubProcess = async ({ commit }, { parentId, company, group = 'procesos-siss' }) => {
  commit('SET_DOCUMENT_SUBPROCESS_LOADING', true);
  const response = await listV2OptionsWithCompany({
    payload: {
      grupoOpcion: group,
      filtros: `deshabilitado:0|padre:${parentId}`
    },
    company
  });

  commit('SET_DOCUMENT_SUBPROCESS', response.data.opciones);
  commit('SET_DOCUMENT_SUBPROCESS_LOADING', false);
};

export const fetchDocuments = async ({ commit }, payload) => {
  commit('SET_DOCUMENTS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: `tipos.documentos-ed.${payload}.item`,
    deshabilitado: 'no'
  });

  commit('SET_DOCUMENTS', response.data.opciones);
  commit('SET_DOCUMENTS_LOADING', false);
};

export const fetchAllDocuments = async ({ commit, state }) => {
  if (state.allDocuments.list.length) return;
  commit('SET_ALL_DOCUMENTS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'tipos.documentos-ed',
    deshabilitado: 'no',
    agrupar: 'si'
  });

  commit('SET_ALL_DOCUMENTS', response.data.opciones);
  commit('SET_ALL_DOCUMENTS_LOADING', false);
};

export const fetchAllDocumentsExternRequest = async ({ commit }, payload) => {
  commit('SET_ALL_DOCUMENTS_LOADING', true);

  const response = await clOpcionesEmpresaList(payload);
  commit('SET_ALL_DOCUMENTS', response.data.opciones);
  commit('SET_ALL_DOCUMENTS_LOADING', false);
};

export const fetchInstitutionTypes = async ({ commit }) => {
  commit('SET_INSTITUTION_TYPES_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'tipos.instituciones-ed',
    deshabilitado: 'no'
  });

  commit('SET_INSTITUTION_TYPES', response.data.opciones);
  commit('SET_INSTITUTION_TYPES_LOADING', false);
};

export const fetchInstitutions = async ({ commit }, payload) => {
  commit('SET_INSTITUTIONS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: `tipos.instituciones-ed.${payload}.item`,
    deshabilitado: 'no'
  });

  commit('SET_INSTITUTIONS', response.data.opciones);
  commit('SET_INSTITUTIONS_LOADING', false);
};

export const fetchInstitutionsDocDigital = async ({ commit }, payload) => {
  commit('SET_INSTITUTIONS_DOC_DIGITAL_LOADING', true);
  const response = await listOptions({
    grupoOpcion: 'io.doc.digital.entidades',
    deshabilitado: 'no',
    orden: payload || ''
  });

  commit('SET_INSTITUTIONS_DOC_DIGITAL', response.data.opciones);
  commit('SET_INSTITUTIONS_DOC_DIGITAL_LOADING', false);
};

export const fetchUserDocDigital = async ({ commit }, payload) => {
  commit('SET_USER_DOC_DIGITAL_LOADING', true);
  const response = await listOptionsDocDigital({
    params: {
      metodo: 'GET',
      api: '/api/usuarios/'
    },
    body: {
      params: {
        idEntidad: payload
      }
    }
  });
  commit('SET_USER_DOC_DIGITAL', response.data.respuesta.result);
  commit('SET_USER_DOC_DIGITAL_LOADING', false);
};

export const setUserLoading = async (
  { commit },
  {
    loading = false
  }
) => {
  commit('SET_LIST_LOADING', { target: 'users', value: loading });
};
export const fetchUsers = async (
  { commit, rootGetters },
  {
    page = 1, limit = 10, query, rolId, grupoId, divisionId, soloLideres, filtroGrupos
  }
) => {
  commit('SET_LIST_LOADING', { target: 'users', value: true });
  try {
    const companyId = rootGetters['Empresas/companyId'];
    const appendQuery = query
      ? { filtro: query }
      : {};

    const payloadQuery = {
      empresaId: companyId,
      pagina: page,
      filas: limit,
      ...(rolId && { rolId }),
      ...(grupoId && { grupoId }),
      ...(divisionId && { divisionId }),
      ...(soloLideres && { soloLideres }),
      ...(filtroGrupos && { filtroGrupos }),
      ...appendQuery
    };

    const {
      data: {
        usuarios: value,
        totalPaginas: pages
      }
    } = await getUsers(payloadQuery);
    const state = { value, limit, pages: parseInt(pages, 10) };
    const indexBy = [
      companyId,
      grupoId,
      divisionId,
      rolId,
      soloLideres,
      filtroGrupos
    ].filter(Boolean).join('-') || 'value';
    // console.log('---- indexedBy 2', indexBy);
    commit('SET_LIST_INDEXED', {
      target: 'users',
      indexedBy: indexBy,
      ...state,
    });
    return state;
  } finally {
    commit('SET_LIST_LOADING', { target: 'users', value: false });
  }
};

export const removeUser = async ({ commit, rootGetters }, { userId }) => {
  const companyId = rootGetters['Empresas/companyId'];
  commit('REMOVE_ITEM_FROM_INDEXED_LIST', {
    target: 'users',
    indexedBy: companyId,
    elementId: userId
  });
};

export const fetchSubjects = async ({ commit, rootState }, payload) => {
  commit('SET_SUBJECTS_LOADING', true);
  commit('SET_SUBJECTS', []);

  switch (payload) {
    case 'unidades': {
      const response = await ioCompanyGroups(
        { empresaId: rootState.Empresas.empresa.id }
      );
      commit('SET_SUBJECTS', { type: payload, list: response.data.grupos });
      break;
    }
    case 'oficinas': {
      const response = await ioCompanyGroups(
        { empresaId: rootState.Empresas.empresa.id, esOficina: 'Y' }
      );
      commit('SET_SUBJECTS', { type: payload, list: response.data.grupos });
      break;
    }
    case 'docDigital': {
      const response = await listOptions({
        grupoOpcion: 'io.doc.digital.organismo',
        deshabilitado: 'no'
      });
      commit('SET_SUBJECTS', { type: payload, list: response.data.opciones });
      break;
    }
    case 'ministerios': {
      const response = await listOptions({
        grupoOpcion: 'tipos.destinos-ed.OIP.item',
        deshabilitado: 'no'
      });
      commit('SET_SUBJECTS', { type: payload, list: response.data.opciones });
      break;
    }
    default:
      console.log('Esta opcion no tiene request');
      break;
  }
  commit('SET_SUBJECTS_LOADING', false);
};

export const fetchGroups = async ({ commit, rootState }) => {
  commit('SET_GROUPS_LOADING', true);
  commit('SET_GROUPS', []);
  const response = await ioCompanyGroups(
    { empresaId: rootState.Empresas.empresa.id }
  );
  commit('SET_GROUPS', response.data.grupos);
  commit('SET_GROUPS_LOADING', false);
};
export const fetchAprovals = async ({ commit }, payload) => {
  commit('SET_APROVALS_LOADING', true);
  const response = await listApprovals(payload);
  commit('SET_APROVALS', response.data.aprobaciones);
  commit('SET_APROVALS_LOADING', false);
  return response;
};

export const fetchOffices = async ({ commit, rootState }, arrfilters) => {
  const filters = arrfilters.map((obj) => obj.filter).join('|');
  commit('SET_OFFICES_LOADING', true);
  commit('SET_OFFICES', []);
  const response = await ioCompanyGroups(
    {
      empresaId: rootState.Empresas.empresa.id,
      filtros: filters
    }
  );
  commit('SET_OFFICES', response.data.grupos);
  commit('SET_OFFICES_LOADING', false);
};

export const getUsersGroup = async ({ commit, rootState }, groupId) => {
  commit('SET_GROUP_USERS_LOADING', true);
  commit('SET_GROUP_USERS', []);
  const response = await getUsersByGroup({
    empresaId: rootState.Empresas.empresa.id,
    pagina: 1,
    filas: 9999,
    groupId
  });
  commit('SET_GROUP_USERS', response.data.usuarios);
  commit('SET_GROUP_USERS_LOADING', false);
};

export const fetchActivities = async ({ commit }) => {
  commit('SET_ACTIVITIES_LOADING', true);
  const response = await listOptions({
    grupoOpcion: 'tipos.actividades-ed',
    deshabilitado: 'no'
  });
  commit('SET_ACTIVITIES', response.data.opciones);
  commit('SET_ACTIVITIES_LOADING', false);
};

export const fetchActivityStates = async ({ commit }, payload) => {
  commit('SET_ACTIVITY_STATES_LOADING', true);

  const response = await listOptions({
    grupoOpcion: `tipos.actividades-ed.${payload}.item`,
    deshabilitado: 'no'
  });

  commit('SET_ACTIVITY_STATES', response.data.opciones);
  commit('SET_ACTIVITY_STATES_LOADING', false);
};

export const fetchUserGroups = async ({ commit, rootState }) => {
  commit('SET_USER_GROUPS_LOADING', true);
  commit('SET_USER_GROUPS', []);
  const response = await ioCompanyGroups(
    {
      empresaId: rootState.Empresas.empresa.id,
      filtros: `usuarioId:${rootState.Usuario.id}`
    }
  );
  commit('SET_USER_GROUPS', response.data.grupos);
  commit('SET_USER_GROUPS_LOADING', false);
};

export const fetchMyDivisions = async ({ commit, rootGetters }) => {
  commit('SET_LIST_LOADING', { target: 'myDivisions', value: true });
  commit('SET_LIST', { target: 'myDivisions', value: [] });
  const { data: { grupos: divisions } } = await ioCompanyGroups(
    {
      empresaId: rootGetters['Empresas/companyId'],
      filtros: `divisiones:${rootGetters['Usuario/currentUserId']}`
    }
  );
  commit('SET_LIST', { target: 'myDivisions', value: divisions });
  commit('SET_LIST_LOADING', { target: 'myDivisions', value: false });
};

export const fetchCompanyDivisions = async ({ commit, rootGetters }) => {
  commit('SET_LIST_LOADING', { target: 'companyDivisions', value: true });
  commit('SET_LIST', { target: 'companyDivisions', value: [] });
  const { data: { grupos: divisions } } = await ioCompanyGroups(
    {
      empresaId: rootGetters['Empresas/companyId'],
      filtros: 'esDivision:Y'
    }
  );
  commit('SET_LIST', { target: 'companyDivisions', value: divisions });
  commit('SET_LIST_LOADING', { target: 'companyDivisions', value: false });
};

export const fetchSanitaryCompanies = async ({ commit }, company) => {
  commit('SET_SANITARY_COMPANIES_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'empresas-sanitarias-ed',
    deshabilitado: 'no',
    company
  });

  commit('SET_SANITARY_COMPANIES', response.data.opciones);
  commit('SET_SANITARY_COMPANIES_LOADING', false);
};

export const fetchIsapres = async ({ commit }) => {
  commit('SET_ISAPRES_LOADING', true);

  const res = await listOptions({
    grupoOpcion: 'isapres-ed',
    deshabilitado: 'no'
  });

  commit('SET_ISAPRES', res.data.opciones);
  commit('SET_ISAPRES_LOADING', false);
};

export const fetchAfps = async ({ commit }) => {
  commit('SET_AFPS_LOADING', true);

  const res = await listOptions({
    grupoOpcion: 'afps-ed',
    deshabilitado: 'no'
  });

  commit('SET_AFPS', res.data.opciones);
  commit('SET_AFPS_LOADING', false);
};

export const fetchBanks = async ({ commit }) => {
  commit('SET_BANKS_LOADING', true);

  const res = await listOptions({
    grupoOpcion: 'bancos-ed',
    deshabilitado: 'no'
  });

  commit('SET_BANKS', res.data.opciones);
  commit('SET_BANKS_LOADING', false);
};

export const fetchAcademicDegree = async ({ commit }) => {
  commit('SET_ACADEMIC_DEGREE_LOADING', true);

  const res = await listOptionsWithCustomParams({
    grupoOpcion: 'academic-degree',
    deshabilitado: 'no',
    orden: '+orden',
  });

  commit('SET_ACADEMIC_DEGREE', res.data.opciones);
  commit('SET_ACADEMIC_DEGREE_LOADING', false);
};

export const fetchNationality = async ({ commit }) => {
  commit('SET_NATIONALITY_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'nationality',
    deshabilitado: 'no'
  });

  commit('SET_NATIONALITY', response.data.opciones);
  commit('SET_NATIONALITY_LOADING', false);
};

export const fetchTitle = async ({ commit }) => {
  commit('SET_TITLE_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'title',
    deshabilitado: 'no'
  });

  commit('SET_TITLE', response.data.opciones);
  commit('SET_TITLE_LOADING', false);
};

export const fetchSubject = async ({ commit }) => {
  commit('SET_SUBJECT_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'subject',
    deshabilitado: 'no'
  });

  commit('SET_SUBJECT', response.data.opciones);
  commit('SET_SUBJECT_LOADING', false);
};

export const fetchCareer = async ({ commit }) => {
  commit('SET_CAREER_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'career',
    deshabilitado: 'no'
  });

  commit('SET_CAREER', response.data.opciones);
  commit('SET_CAREER_LOADING', false);
};

export const fetchUniversity = async ({ commit }) => {
  commit('SET_UNIVERSITY_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'university',
    deshabilitado: 'no'
  });

  commit('SET_UNIVERSITY', response.data.opciones);
  commit('SET_UNIVERSITY_LOADING', false);
};

export const fetchCity = async ({ commit }) => {
  commit('SET_CITY_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'city',
    deshabilitado: 'no'
  });

  commit('SET_CITY', response.data.opciones);
  commit('SET_CITY_LOADING', false);
};

export const fetchResponsibilityCenter = async ({ commit }) => {
  commit('SET_RESPONSIBILITY_CENTER_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'responsibility-center',
    deshabilitado: 'no'
  });

  commit('SET_RESPONSIBILITY_CENTER', response.data.opciones);
  commit('SET_RESPONSIBILITY_CENTER_LOADING', false);
};

export const fetchPaymentPeriod = async ({ commit }) => {
  commit('SET_PAYMENT_PERIOD_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'payment-period',
    deshabilitado: 'no'
  });

  commit('SET_PAYMENT_PERIOD', response.data.opciones);
  commit('SET_PAYMENT_PERIOD_LOADING', false);
};

export const fetchContractPaymentPeriod = async ({ commit }) => {
  commit('SET_CONTRACT_PAYMENT_PERIOD_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'contract-payment-period',
    deshabilitado: 'no'
  });

  commit('SET_CONTRACT_PAYMENT_PERIOD', response.data.opciones);
  commit('SET_CONTRACT_PAYMENT_PERIOD_LOADING', false);
};

export const fetchPeriod = async ({ commit }) => {
  commit('SET_PERIOD_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'period',
    deshabilitado: 'no'
  });

  commit('SET_PERIOD', response.data.opciones);
  commit('SET_PERIOD_LOADING', false);
};

export const fetchHeadOfCareer = async ({ commit }) => {
  commit('SET_HEAD_OF_CAREER_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'head-of-career',
    deshabilitado: 'no'
  });

  commit('SET_HEAD_OF_CAREER', response.data.opciones);
  commit('SET_HEAD_OF_CAREER_LOADING', false);
};

export const fetchAdministrativeSupport = async ({ commit }) => {
  commit('SET_ADMINISTRATIVE_SUPPORT_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'administrative-support',
    deshabilitado: 'no'
  });

  commit('SET_ADMINISTRATIVE_SUPPORT', response.data.opciones);
  commit('SET_ADMINISTRATIVE_SUPPORT_LOADING', false);
};

export const fetchAdministrativeResponsible = async ({ commit }) => {
  commit('SET_ADMINISTRATIVE_RESPONSIBLE_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'administrative-responsible',
    deshabilitado: 'no'
  });

  commit('SET_ADMINISTRATIVE_RESPONSIBLE', response.data.opciones);
  commit('SET_ADMINISTRATIVE_RESPONSIBLE_LOADING', false);
};

export const fetchSchAttachmentsSelectors = async ({ commit }) => {
  commit('SET_SCH_ATTACHMENTS_SELECTORS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'sch-attachments-selectors',
    deshabilitado: 'no',
    orden: '+orden',
  });

  commit('SET_SCH_ATTACHMENTS_SELECTORS', response.data.opciones);
  commit('SET_SCH_ATTACHMENTS_SELECTORS_LOADING', false);
};

export const fetchGrcAttachmentsSelectors = async ({ commit }) => {
  commit('SET_GRC_ATTACHMENTS_SELECTORS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'grc-attachments',
    deshabilitado: 'no',
  });
  commit('SET_GRC_ATTACHMENTS_SELECTORS', response.data.opciones);
  commit('SET_GRC_ATTACHMENTS_SELECTORS_LOADING', false);
};
export const fetchScfAttachmentsSelectors = async ({ commit }) => {
  commit('SET_SCF_ATTACHMENTS_SELECTORS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'scf-attachments',
    deshabilitado: 'no',
  });
  commit('SET_SCF_ATTACHMENTS_SELECTORS', response.data.opciones);
  commit('SET_SCF_ATTACHMENTS_SELECTORS_LOADING', false);
};

export const fetchActAttachmentsSelectors = async ({ commit }) => {
  commit('SET_ACT_ATTACHMENTS_SELECTORS_LOADING', true);

  const response = await listOptions({
    grupoOpcion: 'act-attachments',
    deshabilitado: 'no',
  });
  commit('SET_ACT_ATTACHMENTS_SELECTORS', response.data.opciones);
  commit('SET_ACT_ATTACHMENTS_SELECTORS_LOADING', false);
};

export const fetchProfiles = async (
  { commit, rootGetters },
  { page = 1, limit = 50, query } = {}
) => {
  commit('SET_LIST_LOADING', { target: 'profiles', value: true });
  try {
    const companyId = rootGetters['Empresas/companyId'];

    const payload = {
      pagina: page,
      filas: limit,
      ...(query && { filtro: query })
    };

    const {
      data: {
        perfiles: value,
        totalPaginas: pages
      }
    } = await getProfiles(companyId, payload);

    const state = { value, limit, pages: parseInt(pages, 10) };
    const indexBy = [companyId].filter(Boolean).join('-') || 'value';

    commit('SET_PROFILES_INDEXED', {
      target: 'profiles',
      indexedBy: indexBy,
      id: 'idPerfil',
      ...state
    });

    return state;
  } finally {
    commit('SET_LIST_LOADING', { target: 'profiles', value: false });
  }
};
